import Reveal from "../components/Reveal";
import { Eyebrow } from "../components/Flow";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    testid: "privacy-page",
    body: [
      "BUY CARIBBEAN respects the privacy of its professional contacts and website visitors.",
      "Information submitted through our project inquiry form — such as your name, company, contact details and project information — is used exclusively to review your request and respond to your inquiry.",
      "We do not sell, rent or share your personal information with third parties for marketing purposes.",
      "You may request access, correction or deletion of your information at any time by writing to contactbuycaribbean@gmail.com.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    testid: "terms-page",
    body: [
      "The content of this website is provided for general information about BUY CARIBBEAN and its sourcing, procurement and logistics coordination services between Colombia and Caribbean markets.",
      "Conceptual packages, future platform descriptions and project examples presented on this site are illustrative and do not constitute offers, pricing or representations of completed client work.",
      "Any commercial engagement is subject to a separate written agreement between BUY CARIBBEAN and the client.",
      "For questions regarding these terms, contact contactbuycaribbean@gmail.com.",
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  return (
    <main className="py-20 sm:py-28" data-testid={c.testid}>
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <Reveal>
          <Eyebrow>BUY CARIBBEAN</Eyebrow>
          <h1 className="mt-5 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">{c.title}</h1>
          <div className="mt-8 space-y-5">
            {c.body.map((p, i) => (
              <p key={i} className="text-sm leading-relaxed text-[#0B132B]/75 sm:text-base">
                {p}
              </p>
            ))}
          </div>
          <p className="mt-10 text-xs text-[#0B132B]/40">Last updated: July 2026</p>
        </Reveal>
      </div>
    </main>
  );
}
